import { APICore } from './apiCore';

const api = new APICore();

function addFaultyReceived_API(params: {
    entrydate: String;
    accountid: String;
    sales_categoriesid: String;
    reference: String;
    notes: String;
    totalprice: String;
    cashpaid: String;
    subtotal: String;
    netamount: String;
    invoicedetdata: Object;
}) {
    const baseUrl = '/add-faultyreceived';
    return api.create(`${baseUrl}`, params);
}
function addFaultyReceivedBack_API(params: {
    entrydate: String;
    accountid: String;
    sales_categoriesid: String;
    reference: String;
    notes: String;
    totalprice: String;
    cashpaid: String;
    subtotal: String;
    netamount: String;
    invoicedetdata: Object;
}) {
    const baseUrl = '/add-faultyback';
    return api.create(`${baseUrl}`, params);
}
function addFaultySent_API(params: {
    entrydate: String;
    accountid: String;
    sales_categoriesid: String;
    reference: String;
    notes: String;
    totalprice: String;
    cashpaid: String;
    subtotal: String;
    netamount: String;
    invoicedetdata: Object;
}) {
    const baseUrl = '/add-faultysent';
    return api.create(`${baseUrl}`, params);
}
function addFaultyDecalre_API(params: { entrydate: String; notes: String; invoicedetdata: Object }) {
    const baseUrl = '/add-faultydeclare';
    return api.create(`${baseUrl}`, params);
}
function updFaultyDecalre_API(params: { id: string; entrydate: String; notes: String; invoicedetdata: Object }) {
    const baseUrl = `/update-faultydeclare/${params.id}`;
    return api.update(`${baseUrl}`, params);
}
function updFaultyReceivedBack_API(params: {
    id: string;
    entrydate: String;
    accountid: String;
    sales_categoriesid: String;
    reference: String;
    notes: String;
    totalprice: String;
    cashpaid: String;
    subtotal: String;
    netamount: String;
    invoicedetdata: Object;
}) {
    const baseUrl = `/update-faultyback/${params.id}`;
    return api.update(`${baseUrl}`, params);
}
function updFaultyReceived_API(params: {
    id: string;
    entrydate: String;
    accountid: String;
    sales_categoriesid: String;
    reference: String;
    notes: String;
    totalprice: String;
    cashpaid: String;
    subtotal: String;
    netamount: String;
    invoicedetdata: Object;
}) {
    const baseUrl = `/update-faultyreceived/${params.id}`;
    return api.update(`${baseUrl}`, params);
}
function updFaultySent_API(params: {
    id: string;
    entrydate: String;
    accountid: String;
    sales_categoriesid: String;
    reference: String;
    notes: String;
    totalprice: String;
    cashpaid: String;
    subtotal: String;
    netamount: String;
    invoicedetdata: Object;
}) {
    const baseUrl = `/update-faultysent/${params.id}`;
    return api.update(`${baseUrl}`, params);
}
export {
    addFaultyReceivedBack_API,
    updFaultyReceivedBack_API,
    updFaultySent_API,
    addFaultySent_API,
    addFaultyReceived_API,
    updFaultyDecalre_API,
    updFaultyReceived_API,
    addFaultyDecalre_API,
};
